module.exports = __webpack_public_path__ + "static/img-featured-contributor-robin-473ef6ed3029a8f39f3f6c3db9f9ad65.jpg";